import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #000000;
  font-family: inherit;
  color: ${DEFAULT_COLORS.ink.light};
  z-index: 200;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 32px;
  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`;

export const BrandSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const Divider = styled.span`
  height: 32px;
  border-left: 2px solid ${DEFAULT_COLORS.white};
  opacity: 0.3;
  margin-left: 16px;
`;

export const PortalText = styled.p`
  font-size: 14px;
  color: ${DEFAULT_COLORS.white};
  margin-left: 16px;
`;

export const ProfileSection = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const IconCircle = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  box-sizing: border-box;
  background: ${DEFAULT_COLORS.white};
  border: 2px solid ${DEFAULT_COLORS.whiteBorderSubtle};
  border-radius: 50%;
  cursor: pointer;
  color: ${DEFAULT_COLORS.black};
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${DEFAULT_COLORS.whiteBorderHover};
  }

  svg {
    height: 22px;
    width: 22px;
  }
`;

export const CartBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${DEFAULT_COLORS.accent.salmon};
  color: ${DEFAULT_COLORS.white};
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
`;

export const ProfileButton = styled.button`
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  align-items: center;
  gap: 12px;
`;

export const ProfileIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  background: ${DEFAULT_COLORS.white};
  border: 2px solid ${DEFAULT_COLORS.whiteBorderSubtle};
  border-radius: 50%;
  color: ${DEFAULT_COLORS.black};

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const UserNameWrapper = styled.span`
  color: ${DEFAULT_COLORS.white};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserName = styled.span`
  font-size: 1rem;
  white-space: nowrap;
`;

export const DropdownIcon = styled.svg<{ isOpen: boolean }>`
  height: 20px;
  width: 20px;
  display: inline-block;
  color: currentColor;
  transition: transform 0.2s ease;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const MenuItemsWrapper = styled.div`
  position: absolute;
  right: 4px;
  top: 100%;
  margin-top: 15px;
  width: 160px;
  transform-origin: top right;
  background-color: ${DEFAULT_COLORS.white};
  border-radius: 6px;
  box-shadow: 0 10px 15px -3px ${DEFAULT_COLORS.grey10},
    0 4px 6px -2px ${DEFAULT_COLORS.grey5};
  ring: 1px solid ${DEFAULT_COLORS.grey5};
  outline: none;
  animation: slideDown 0.15s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const MenuItemsContainer = styled.div`
  padding: 4px;
`;

export const MenuItemLink = styled.a<{ active: boolean }>`
  display: flex;
  width: calc(100% - 16px);
  align-items: center;
  border-radius: 4px;
  padding: 8px 8px;
  font-size: 14px;
  text-decoration: none;
  background-color: ${props =>
    props.active ? DEFAULT_COLORS.primary : 'transparent'};
  color: ${props =>
    props.active ? DEFAULT_COLORS.white : DEFAULT_COLORS.text.primary};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props =>
      props.active
        ? DEFAULT_COLORS.primary
        : DEFAULT_COLORS.controls.grey.background};
  }

  svg {
    margin-right: 8px;
    height: 24px;
    width: 24px;
  }
`;
